export default "__VITE_ASSET__GRErgqwC__"